import { render, staticRenderFns } from "./GeneralSettingDeliveryInterval.vue?vue&type=template&id=4569cd4c&"
import script from "./GeneralSettingDeliveryInterval.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingDeliveryInterval.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports